import getElements from '@utilities/get-elements';

/**
 * toggles zero or more classes on zero or more elements on or off
 *
 * usage examples:
 * toggleClass('body', 'is-mobile', true)
 * toggleClass(document.querySelector('.foo'), 'bar', true)
 * toggleClass(document.querySelectorAll('.many'), ['foo', 'bar'], true)
 */
const toggleClass = function(selector, className, onoff) {
  const els = getElements(selector);
  const method = onoff ? 'add' : 'remove';
  const classNames = typeof className === 'string' ? [className] : className;
  els.forEach(el => {
    classNames.forEach(cn => {
      el.classList[method](cn);
    });
  });
};

export default toggleClass;
